import React from "react";

import { DISPENSARY_PLACEHOLDER_PHOTO } from "@/constants/dispensary";
import { Dispensary } from "@/custom-types/MenuItemCard";
import { getDistance } from "@/utils/distance";

import Image from "@/components/Image";

const HorizontalCardPickupFulfillmentInfo = ({
  dispensary,
}: {
  dispensary: Dispensary;
}) => {
  const { country, distanceMi, logoUrl, name } = dispensary;

  //TODO: refactor to be passed in the backend
  const dispensaryImage = logoUrl || DISPENSARY_PLACEHOLDER_PHOTO;

  return (
    <>
      <>
        <div className="mt-sm flex" data-testid="menu-item-card__fulfillment">
          <div
            className="flex-shrink-0 pt-xs"
            style={{ height: "24px", width: "24px" }}
          >
            <Image
              src={dispensaryImage}
              alt={name}
              sizes={[24]}
              className="rounded"
            />
          </div>
          <div
            className="flex flex-col font-bold text-xs ml-md"
            data-testid="menu-item-card__pickup-info"
          >
            <div className="text-wrap">{name}</div>
            <span>
              {`Pickup ${getDistance(distanceMi, country, true)} away`}
            </span>
          </div>
        </div>
      </>
    </>
  );
};

export default HorizontalCardPickupFulfillmentInfo;
